import { jsx as _jsx } from "react/jsx-runtime";
export function LoadingState({ label = 'Загрузка...' }) {
    return (_jsx("div", { role: "status", "aria-live": "polite", style: { padding: 16, color: '#555' }, children: label }));
}
//# sourceMappingURL=LoadingState.js.map